import React, { useRef } from 'react';
import Icons from '../../Icons';

import './style.scss';

/**
 * 
 * @param {Object} children - Dom elements
 * @param {string} type - Values: button, submit, reset
 * @param {string} size - Values: xs, md, lg
 * @param {string} iconPosition - Values: left, right
 * @param {string} theme - Values: default, accent, highlight, white
 * @param {(string|Array)} className
 * @param {(Object)} style
 * @param {string} label
 * @param {string} icon
 * @param {boolean} blank
 * @param {boolean} disabled
 * @param {boolean} round
 * @param {string} color
 * @param {string} colorFilled
 * 
 * @param {function} onClick
 * @returns 
 */

const CButton = ({
    children,
    label = '',
    icon = '',
    iconPosition = 'left',
    iconStyles = '',
    type = 'button',
    className = '',
    style = {},
    size = 'md',
    theme = 'default',
    blank = false,
    disabled = false,
    round = false,
    color = '',
    colorFilled = '',
    onClick,
}) => {
    const buttonRef = useRef(null);

    return (
        <button
            ref={buttonRef}
            className={`comdi-button comdi-button--${size} comdi-button--${theme} comdi-button--icon-${iconPosition} ${blank && 'comdi-button--blank'} ${round && 'comdi-button--round'} ${!!color && 'comdi-button--colored'} ${!!colorFilled && 'comdi-button--filled'} ${!!iconStyles && `comdi-button--${iconStyles}`} ${Array.isArray(className) ? className.join(' ') : className}`}
            type={type}
            disabled={disabled}
            style={{
                ...style,
                borderTop: !!color ? `2px solid ${color}` : 0,
                backgroundColor: colorFilled,
            }}
            onClick={onClick}
            onMouseEnter={() => !!colorFilled === false && buttonRef.current && !blank ? buttonRef.current.style.backgroundColor = color : false}
            onMouseLeave={() => !!colorFilled === false && buttonRef.current && !blank ? buttonRef.current.style.backgroundColor = '' : false}
        >
            {
                children ||
                <>
                    { !!icon && <span className='comdi-button-icon'><Icons name={icon} /></span> }
                    { !!label && <span className='comdi-button-label'>{label}</span> }
                </>
            }
        </button>
    )
};

export default CButton;
